/*summary: this code ensures that the HubSpot Conversations widget is properly loaded, 
and it continuously checks its status at intervals until the widget is loaded or a certain number of attempts have been made. 
If successful, it removes the "hide" class from a specific element, making the widget visible.*/
document.addEventListener("DOMContentLoaded", () => {
  // Sticky chat widget scroll-in logic using CSS classes
  const stickyWidget = document.querySelector(".section--floating-widget");
  if (stickyWidget) {
    // Easily adjust how far to scroll before showing the widget:
    const scrollThreshold = window.innerHeight * 0.5; // 0.5 = 50% of viewport height
    stickyWidget.classList.add("sticky--offscreen");
    let widgetShown = false;
    function handleStickyWidgetScroll() {
      if (!widgetShown && window.scrollY > scrollThreshold) {
        stickyWidget.classList.remove("sticky--offscreen");
        stickyWidget.classList.add("sticky--onscreen");
        widgetShown = true;
      } else if (widgetShown && window.scrollY <= scrollThreshold) {
        stickyWidget.classList.remove("sticky--onscreen");
        stickyWidget.classList.add("sticky--offscreen");
        widgetShown = false;
      }
    }
    window.addEventListener("scroll", handleStickyWidgetScroll);
    // Run on load in case already scrolled
    handleStickyWidgetScroll();
  }
  window.hsConversationsOnReady = [
    () => {
      function removeHiddenClass() {
        document
          .querySelector(".section--floating-widget .sticky__wrapper")
          .classList.remove("hide");
      }

      let i = 1; //set counter to 1

      function checkAtInterval(status) {
        //  create a loop function
        setTimeout(function () {
          //  call a 3s setTimeout when the loop is called
          status = window.HubSpotConversations.widget.status(); //  redefine widget status
          i++; //  increment the counter
          if (i < 11 && status.loaded == false) {
            //  if the counter < 11 and the status of the widget is still false,
            checkAtInterval(); //   call the check function   again which will trigger another
            console.log(`try ${i} - loaded: ${status.loaded}`);
          } else {
            // otherwise (if the status of the widget is true or more than 5 attempts at checking the status have been made ), remove the hidden class from the sticky widget
            console.log(`try ${i} - loaded: ${status.loaded}`);
            removeHiddenClass();
          }
        }, 3000);
      }

      function loadWidget(removeHiddenClass) {
        // window.HubSpotConversations.widget.load();
        let status = window.HubSpotConversations.widget.status();
        checkAtInterval(status, removeHiddenClass);
      }
      loadWidget(removeHiddenClass);
    },
  ];
});
